<template>
  <div
    id="header"
    class="container-fluid"
    :class="{ 'header-scrolled': isScrolled }"
  >
    <div class="header-nav-container">
      <!-- 导航Logo -->
      <div class="header-nav-logo" @click="$router.push('/')">
        <img class="logo" src="@/assets/img/logoTitle.png" alt="利达建安" />
        <div class="logo-divider"></div>
        <div class="logo-text">
          <div class="slogan">工装设计施工一体化服务</div>
          <div class="phone">0755-27822259</div>
        </div>
      </div>

      <!-- 电脑端导航 -->
      <ul class="header-nav-wrapper hidden-xs">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="{ active: navIndex == index }"
          @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = -1"
        >
          <router-link
            :to="item.path"
            @click.native="navClick(index, item.name)"
          >
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="el-icon-arrow-down"
            ></span>
          </router-link>

          <!-- 二级菜单 -->
          <transition name="fade">
            <ul
              v-if="item.children.length > 0 && hoverIndex === index"
              class="sub-menu"
            >
              <li v-for="(sub, subIndex) in item.children" :key="subIndex">
                <router-link
                  :to="sub.path"
                  @click.native="navClick(index, item.name)"
                  >{{ sub.name }}</router-link
                >
              </li>
            </ul>
          </transition>
        </li>
      </ul>

      <!-- 手机端菜单按钮 -->
      <div class="menu-btn visible-xs" @click="isMenuOpen = !isMenuOpen">
        <i :class="isMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
      </div>
    </div>

    <!-- 手机端导航内容 -->
    <transition name="slide">
      <div v-if="isMenuOpen" class="mobile-nav visible-xs">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            @click="mobileNavClick(index, item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex") || 0,
      hoverIndex: -1,
      isScrolled: false,
      isMenuOpen: false,
      homeSectionIndex: 0,
      ticking: false,
      navList: [
        { name: "首页", path: "/", children: [] },
        {
          name: "项目案例",
          path: "/case?catId=0",
          children: [
            { name: "精装案例", path: "/case?catId=0" },
            { name: "机电案例", path: "/case?catId=1" },
            { name: "暖通案例", path: "/case?catId=2" }
          ]
        },
        {
          name: "装修服务",
          path: "/software?id=0",
          children: [
            { name: "定制化装修", path: "/software?id=0" },
            { name: "免费设计", path: "/software?id=1" },
            { name: "装修报价", path: "/software?id=2" },
            { name: "服务优势", path: "/software?id=3" }
          ]
        },
        { name: "装修知识", path: "/DecorationKnowledge", children: [] },
        {
          name: "关于我们",
          path: "/newsinformation",
          children: []
        },
        { name: "联系我们", path: "/contactus", children: [] }
      ]
    };
  },
  computed: {
    isHomePage() {
      return this.$route.path === "/" || this.$route.path === "/home";
    }
  },
  watch: {
    $route: {
      handler(to) {
        this.handleScroll();
        this.isMenuOpen = false;
        this.updateNavIndex(to);
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener(
      "home-section-change",
      this.handleHomeSectionChange
    );
    this.handleScroll(); // Initial check
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener(
      "home-section-change",
      this.handleHomeSectionChange
    );
  },
  methods: {
    updateNavIndex(route) {
      const path = route.path;
      const index = this.navList.findIndex((item, idx) => {
        // 特殊处理首页：/ 或 /home 都指向索引 0
        if (idx === 0 && (path === "/" || path === "/home")) return true;

        const itemPathBase = item.path.split("?")[0];

        // 1. 基础路径匹配 (如 /case?id=0 匹配 /case)
        if (itemPathBase === path) return true;

        // 2. 二级菜单匹配
        if (item.children && item.children.length > 0) {
          if (item.children.some(sub => sub.path.split("?")[0] === path))
            return true;
        }

        // 3. 详情页关联匹配
        if (item.name === "项目案例" && path === "/caseDetail") return true;
        if (item.name === "装修知识" && path === "/KnowledgeDetail")
          return true;

        return false;
      });

      // 额外的首页路径兜底判断
      let finalIndex = index;
      if (finalIndex === -1 && (path === "/" || path === "/home")) {
        finalIndex = 0;
      }

      if (finalIndex !== -1) {
        this.navIndex = finalIndex;
        sessionStorage.setItem("navIndex", finalIndex);
      }
    },
    handleHomeSectionChange(e) {
      this.homeSectionIndex = e.detail;
      this.requestTick();
    },
    handleScroll() {
      this.requestTick();
    },
    requestTick() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateHeaderState();
          this.ticking = false;
        });
        this.ticking = true;
      }
    },
    updateHeaderState() {
      // 简化逻辑：仅根据滚动距离触发高度缩减，背景始终保持白色
      const shouldScroll = window.scrollY > 50;

      if (this.isScrolled !== shouldScroll) {
        this.isScrolled = shouldScroll;
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.isMenuOpen = false;
    },
    mobileNavClick(index, item) {
      this.navClick(index, item.name);
      this.$router.push(item.path);
    }
  }
};
</script>

<style scoped>
#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 85px;
  z-index: 1000;
  /* 精确指定 transition 属性，避免 all 带来的性能损耗 */
  transition: height 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  /* 开启硬件加速 */
  will-change: height, box-shadow;
  background: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05); /* 默认带有轻微阴影提升层次 */
}

#header.header-scrolled {
  height: 70px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.header-nav-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px; /* 缩小侧边距 */
}

.header-nav-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 1001;
}

.logo {
  height: 48px; /* 微调Logo尺寸 */
  transition: height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-scrolled .logo {
  height: 38px;
}

/* 移除原有的 scrolled 颜色覆盖，统一使用黑色系 */
.logo-divider {
  width: 1px;
  height: 24px;
  background: rgba(0, 0, 0, 0.1); /* 统一为深色 */
  margin: 0 20px;
  transition: height 0.4s;
}

.header-scrolled .logo-divider {
  height: 18px;
}

.logo-text {
  color: #1a1a1a; /* 统一为黑色 */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.slogan {
  font-size: 14px; /* 稍微缩小 */
  font-weight: 700;
  letter-spacing: 2px; /* 增加字间距更有设计感 */
  text-transform: uppercase;
  line-height: 1.2;
}

.phone {
  font-size: 12px;
  opacity: 0.8;
  margin-top: 2px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.header-nav-wrapper {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.header-nav-wrapper > li {
  margin-left: 40px;
  position: relative;
}

.header-nav-wrapper > li > a {
  color: #1a1a1a; /* 统一为黑色 */
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 0; /* 恢复正常内边距 */
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  position: relative; /* 确保 ::after 相对于 a 标签定位 */
}

/* 在二级菜单上方创建一个透明的“桥梁”，防止鼠标移出时菜单消失 */
.header-nav-wrapper > li::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 20px;
  background: transparent;
  z-index: 10;
}

.header-nav-wrapper > li > a span {
  font-size: 12px;
  margin-left: 5px;
  transition: transform 0.3s;
}

.header-nav-wrapper > li > a::after {
  content: "";
  position: absolute;
  bottom: -5px; /* 强制定位在文字下方 */
  left: 0;
  width: 0;
  height: 2px;
  background: #31a4f5;
  transition: width 0.3s ease;
}

.header-nav-wrapper > li:hover > a::after,
.header-nav-wrapper > li.active > a::after {
  width: 100%;
}

.header-nav-wrapper > li:hover > a,
.header-nav-wrapper > li.active > a {
  color: #31a4f5;
}

.header-scrolled .header-nav-wrapper > li:hover > a,
.header-scrolled .header-nav-wrapper > li.active > a {
  color: #1577c2;
}

.header-scrolled .header-nav-wrapper > li > a::after {
  background: #1577c2;
}

.header-nav-wrapper > li:hover > a span {
  transform: rotate(180deg);
}

/* 二级菜单 */
.sub-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 15px 0;
  min-width: 160px;
  list-style: none;
  margin-top: 0; /* 移除外边距，改用 top 偏移 */
  opacity: 0;
  visibility: hidden;
  transition: transform 0.3s ease, opacity 0.3s ease, visibility 0.3s ease;
  z-index: 1000;
}

/* 在二级菜单上方创建一个透明的“桥梁”，防止鼠标移出时菜单消失 */
.sub-menu::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  height: 20px;
  background: transparent;
}

.header-nav-wrapper > li:hover .sub-menu {
  transform: translateX(-50%) translateY(0);
  opacity: 1;
  visibility: visible;
}

.sub-menu li a {
  display: block;
  padding: 10px 25px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.3s, color 0.3s, padding-left 0.3s;
}

.sub-menu li a:hover {
  background: #f8f9fa;
  color: #1577c2;
  padding-left: 30px;
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

.menu-btn {
  font-size: 24px;
  color: #1a1a1a; /* 统一为黑色 */
  cursor: pointer;
}

.mobile-nav {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  background: #fff;
  height: calc(100vh - 70px);
  z-index: 999;
  padding: 20px;
}

.mobile-nav ul {
  list-style: none;
  padding: 0;
}

.mobile-nav li {
  padding: 15px 0;
  font-size: 18px;
  border-bottom: 1px solid #eee;
  color: #333;
}

@media screen and (max-width: 768px) {
  .header-nav-container {
    padding: 0 20px;
  }
  .logo-divider,
  .logo-text {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue